import { render, staticRenderFns } from "./FamilyClientDisplayAndEdit.vue?vue&type=template&id=0f6d238c&scoped=true&"
import script from "./FamilyClientDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./FamilyClientDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./FamilyClientDisplayAndEdit.vue?vue&type=style&index=0&id=0f6d238c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d238c",
  null
  
)

export default component.exports